module.exports = "<div class=\"swiper-container\" (swipeLeft)=\"moveNext($event)\" (swipeRight)=\"moveBack($event)\">\n    <ng-content></ng-content>    \n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/vdgm-swiper/vdgm-swiper.template.html
// module id = 836
// module chunks = 2